export default {
    route: {
        index: '首页',
        BillDetails: '账单核对详情',
        bill: '账单核对',
        settle: '结算申请',
        SettleDetails: '结算申请详情',
        deposit: '押金管理',
        DepositDetails: '押金管理详情',
        cost: '费用核对',
        distribution: '运配',
        warehouse: '仓储',
        loadAndUnload: '装卸',
        deliver: '快递',
        install: '网点安装',
        networkDistribution: '网点配送',
        manualEstimate: '手工预估',
        fine: '罚扣款',
        fineDetails: '罚扣款详情',
        statement: '往来对账单',
        StatementDetails: '往来对账单详情',
        invoiceRegistration: '开票注册',
        invoiceManageDetails: '发票管理详情'
    }
};